import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['return', { 'in-modal': _ctx.inModal }])
  }, [
    _createVNode(_component_fbx_button, {
      theme: "link",
      class: "italic",
      "button-text": `Return to ${_ctx.returnApp} Dashboard`,
      onClick: _ctx.routeToDashboard
    }, null, 8, ["button-text", "onClick"])
  ], 2))
}